module.exports = __webpack_public_path__ + "img/service_2.79132c0a.jpg";